// Kelvin Analytics Plugin
// Sends analytics events to backend via sendBeacon (fallback to fetch)

const TRACKING_EVENT_PATH = '/tracking/event'
const TRACKING_PAGE_PATH = '/tracking/page'

function sendToBackend (path, payload) {
  const data = JSON.stringify(payload)

  // Try sendBeacon first (works on page unload, doesn't block)
  if (navigator.sendBeacon) {
    const blob = new Blob([data], { type: 'application/json' })
    const success = navigator.sendBeacon(path, blob)
    if (success) return
  }

  // Fallback to fetch with keepalive
  fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: data,
    keepalive: true
  }).catch(() => {
    // Silently fail - analytics should not break the app
  })
}

function buildPayload (payload) {
  const userId = payload.userId || null
  const traits = payload.traits || {}

  return {
    user_id: userId,
    traits,
    timestamp: new Date().toISOString(),
    context: {
      userAgent: navigator.userAgent
    }
  }
}

export default function kelvinPlugin () {
  return {
    name: 'kelvin-plugin',

    config: {
      storage: false
    },

    page: ({ payload }) => {
      const basePayload = buildPayload(payload)
      const pagePayload = {
        ...basePayload,
        name: payload.properties.name || null,
        properties: payload.properties || {}
      }

      sendToBackend(TRACKING_PAGE_PATH, pagePayload)
    },

    track: ({ payload }) => {
      const basePayload = buildPayload(payload)
      const trackPayload = {
        ...basePayload,
        event: payload.event,
        properties: payload.properties || {}
      }

      sendToBackend(TRACKING_EVENT_PATH, trackPayload)
    }
  }
}
